<template>
  <div class="detail">
    <div class="wraper">
      <div class="head-info">
        <div class="backMain">
            <a @click="$router.back(-1)">&lt;&lt;返回</a>
        </div>
        <div class="avatar">
          <div class="detail">
            <img v-if="isHasAvatar" ref="headAvatar" :src="avatar"  alt="" >
            <div v-if="!isHasAvatar" class="name">{{headDefaultText}}</div>
            <span class="changeAvatar"  @click="handleUploadAvatar" v-if="permissionState">更换头像</span>
          </div>
        </div>
        <div v-if="personalDetail">
          <h4 class="des" v-html="personalDetail.basicInfo.name"></h4>
        </div>
        <div v-if="personalDetail && positionDetail">
          <p class="dep" v-if="personalDetail.workInfoList.length>0||positionDetail.positionInfo.departmentName">{{positionDetail.positionInfo.departmentName}} {{personalDetail.workInfoList.length>0?personalDetail.workInfoList[0].position:''}}</p>
          <p class="dep" v-else>部门岗位未填写</p>
        </div>
        <p v-if="positionDetail">
          <span class="tag">司龄：{{positionDetail.positionInfo.companyAge}}</span>
        </p>
        <div class="printdoc">
          <Button size="large" type="primary" @click="printdoc">打印入职审批表</Button>
        </div>
      </div>
      <div class="employee-nav">
        <ul>
          <li
            class="route"
            v-for="(item,index) in navList"
            :key="index"
          >
            <router-link tag="span" :to="{path:item.path }">
              <em class="reset">{{item.name}}</em>
            </router-link>
          </li>
        </ul>
      </div>
      <div class="">
        <router-view/>
      </div>
    </div>
    <upload-avatar ref="uploadAvatar" @avatarPicBase64="avatarPicBase64"></upload-avatar>
  </div>
</template>

<script>
    import { encryptionSignResult} from '@/libs/tools'
    import { personaldetail,positiondetail} from '@/api/data'
    import { editheadimg } from '@/api/writeIn'
    import baseURL from '_conf/url'
    import qs from 'qs'; //序列化  post请求用
    import UploadAvatar from "../../components/uploadAvatar/uploadAvatar";
    export default {
      components: {UploadAvatar},
      data(){
        return{
          permissionState:false,
          emId:0, //员工ID
          personalDetail:'', //个人信息
          positionDetail:'', //岗位信息
          isHasAvatar:true,
          avatar:'',
          headDefaultText:'',//无头像时名字代替
          navList:[
            {
              name: '个人信息',
              path: 'personal-info'
            },
            {
              name: '联系信息',
              path: 'contact-detail'
            },
            {
              name: '岗位信息',
              path: 'position-detail'
            },
            {
              name: '合同信息',
              path: 'contract-detail'
            }
          ]
        }
      },
      methods:{
        handleUploadAvatar(){
          this.$refs.uploadAvatar.openModal();
        },
        avatarPicBase64(data){
          let _this = this;
          let objData = encryptionSignResult({img:data,employeeId:parseInt(this.$route.params.id)});
          // console.log(objData)
          editheadimg(objData) //base64通过接口获取 url
            .then(res => {
              // console.log(res)
              if(res){
                _this.isHasAvatar = true;
                setTimeout(()=>{
                  _this.$refs.headAvatar.src = res.data.img;
                },300)
              }
            })
            .catch((error)=>{
              console.log('系统错误');
            })
        },
        getPersonaldetail(emId){ //-员工个人信息 银行卡 社保卡 教育 工作经历
          let _this = this;
          let objData = encryptionSignResult({employeeId:emId});
          personaldetail(objData).then(res => {
            if(res){
              _this.personalDetail = res.data; //个人信息
              let basicInfo = res.data.basicInfo;
              if(basicInfo){
                let emName = basicInfo.name;
                let avatar = basicInfo.photo;
                _this.avatar = avatar;
                if(!avatar){
                  _this.isHasAvatar = false;
                  _this.headDefaultText = emName.substring(emName.length-2)
                }
              }else{
                _this.isHasAvatar = false;
                _this.headDefaultText = '信息错误'
              }

            }
          })
        },
        getPositiondetail(emId){ //员工岗位信息,职业证书信息
          let objData = encryptionSignResult({employeeId:emId});
          positiondetail(objData).then(res => {
            this.positionDetail = res.data;
          })
        },
        //打印入职审批表
        printdoc(){
          let field = {id:this.$route.params.id};
          let objData = encryptionSignResult(field);
          let query = qs.stringify(objData);
          // console.log(query)
          window.location.href = baseURL + "/employee/waitentry/printempword?" + query;
        },
      },
      mounted(){
        let emId = this.$route.params.id;
        if(emId){
          this.$nextTick(function(){
            this.getPersonaldetail(emId); //员工个人信息 银行卡 社保卡 教育 工作经历
            this.getPositiondetail(emId) //员工岗位信息,职业证书信息
          });
        };
        this.permissionState = this.$store.state.user.access.some(item=>{
          return item === 2;
        });
      },
      created(){

      },
      // beforeRouteLeave(to, from, next){
      //   console.log('路由离开')
      //   console.log(to)
      //   to.meta.keepAlive = false;
      //   if(to.name === 'rosterList'){
      //     //原来的列表页
      //     to.meta.keepAlive = true;
      //     next();
      //   }else{
      //     //走其他列表页
      //     to.meta.keepAlive = false;
      //     next();
      //   }
      // },


      // beforeRouteEnter (to, from, next) {
      //   next(vm =>{
      //     vm.formUrl = from.path;
      //     console.log(vm.formUrl)
      //   });
      // },
      // beforeRouteLeave(to, from, next) {
      //   to.meta.keepAlive = false;
      //   if(to.path == this.formUrl){
      //     to.meta.keepAlive = true;
      //     next();
      //     return
      //   }else{
      //     to.meta.KeepAlive = false;
      //     window.localStorage.removeItem('isRefresh')
      //     this.$destroy();
      //     next();
      //     return
      //   }
      // },

    }
</script>

<style scoped>
  .backMain{
    position: absolute;
    left: 20px;
    top: 15px;
  }
  .head-info{
    position: relative;
    width: 100%;
    min-height: 231px;
    padding: 52px 32px 48px 207px;
    border-radius: 4px;
    border: 1px solid #f0f4f8;
    box-shadow: 0 4px 15px rgba(73, 80, 96, 0.1);
  }
  .des {
    display: inline-block;
    margin: 0 8px 12px 0;
    font-size: 30px;
    font-weight: normal;
  }
  .dep{
    margin-bottom: 12px;
    color: #495060;
    font-size: 14px;
  }
  .tag {
    position: relative;
    display: inline-block;
    height: 20px;
    margin-right: 16px;
    padding: 0 8px;
    text-align: center;
    font-size: 12px;
    color: #80848f;
    border: 1px solid #e1e6eb;
    border-right-color: transparent;
  }
  .tag::before, .tag::after {
    position: absolute;
    content: '';
    display: inline-block;
    border: 1px solid #e1e6eb;
  }
  .tag::before {
    width: 15px;
    height: 15px;
    right: -8px;
    top: 1px;
    border-bottom-color: transparent;
    border-left-color: transparent;
    transform: rotate(45deg);
  }
  .avatar{
    position: absolute;
    left: 55px;
    top: 48px;
  }
  .avatar .detail {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 120px;
    width: 120px;
    height: 120px;
    border-radius: 50%;
    background: #bad9ff;
    overflow: hidden;
  }
  .avatar .detail:hover .changeAvatar{display: block;text-align: center;}
  .avatar .detail .name {
    width: 100%;
    text-align: center;
    color: #fff;
    font-size: 36px;
  }
  .avatar .detail .changeAvatar {
    display: none;
    position: absolute;
    width: 120px;
    height: 40px;
    bottom: 0;
    left: 0;
    color: #fff;
    line-height: 40px;
    cursor: pointer;
    background: rgba(0, 0, 0, 0.3);
  }
  .printdoc{float:right;margin:-32px 0 0;}
  .employee-nav {
    position: relative;
    text-align: center;
    margin: 40px 0;
  }
  .employee-nav .router-link-active {
    border: 1px solid #0bb27a;
    color: #0bb27a;
  }
  .route{
    display: inline-block;
    position: relative;
    margin: 0 10px;
  }
  .route span{
    z-index: 1;
    position: relative;
    display: inline-block;
    height: 30px;
    border-radius: 15px;
    padding: 0 15px;
    line-height: 28px;
    border: 1px solid transparent;
    font-size: 14px;
    cursor: pointer;
    color: #495060;
    font-size: 14px;
  }
  .reset{
    font-style: normal;
  }
</style>



// WEBPACK FOOTER //
// src/view/employee/detail/employee-info.vue